import dayjs from "dayjs";

/**
 * @description 转换16进制到CSS颜色
 * @param hex 16进制
 * @return string
 */
export const hexToColor = (hex: string): string => {
    console.log(hex)
    if (hex) return hex.replace("0x", "#")
    else return ""
};

/**
 * 距截止时间的剩余天数；入参是秒级 Unix 截止时间，负数代表已超期。
 * 未来按整天向下取整（0 = 24 小时内）；超期按已满整天计，但不足一天也至少算 1 天，
 * 避免 `dayjs.diff` 向零截断把刚超期显示成「已超期 0 天」。
 */
export const calcRemainDays = (deadlineSeconds: number): number => {
    const diffSeconds = deadlineSeconds - dayjs().unix();
    const days = Math.floor(Math.abs(diffSeconds) / 86400);
    return diffSeconds >= 0 ? days : -Math.max(days, 1);
}

export const formatTime = (time: number, format: string): string => {
    return dayjs(time * 1000).format(format)
}

/** 保留可读文件名，去掉 COS 对象键不安全的字符并限制长度 */
export function sanitizeCosFileName(name: string): string {
    const trimmed = name.trim().replace(/\0/g, "") || "file";
    return trimmed.replace(/[/\\?#]/g, "_").slice(0, 200);
}

/**
 * @description: 空判断
 * @param {*} obj
 * @return {*}
 */
export const isEmpty = (obj: any): any => {
    return (typeof obj === 'undefined' || obj === null || obj === "" || obj === '');
};

/**
 * 获取文件扩展名
 * @param {*} fileName
 * @returns
 */
export function getFileExt(fileName: string) {
    const index = fileName.lastIndexOf(".");
    const suffix = fileName.substr(index + 1);
    if (isEmpty(suffix)) {
        return suffix;
    }
    return suffix.toLowerCase();
}

/**
 * 将单位为分的产品，转换展示以元为单位的价格
 */
export function convertFenToYuan(price: number) {
    return Number(price / 100).toFixed(2);
}

/**
 * 将单位为元的价格转为分（整数）。超过两位小数按四舍五入，保证接单 / 橱窗 / 改价各页面对
 * 同一个输入得到同样的分数。负号要保留：`AdjustPriceModal` 靠 `deltaFen <= 0` 挡非法输入，
 * 吞掉负号会把「降价 -200」变成「涨价 200」且按钮可点。无法解析的输入按 0 处理。
 */
export function convertYuanToFen(price: number | string) {
    const value = Number(String(price).replace(/[^\d.-]/g, ""));
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
}

/**
 * 将wxPath路径构建为文件名
 * @param wxPath
 */
export function buildFileNameFromWxFile(wxPath: string) {
    return wxPath.substring(wxPath.lastIndexOf('/') + 1);
}


/**判断是否是手机号**/
export function isPhoneNumber(tel: string) {
    const reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
    return reg.test(tel);
}
